/**
 * Copyright (c) Mayoral Moda Infantil, S.A.U. and affiliates.
 */

import { ApolloCache } from '@apollo/client';
import { loggedInVar } from '@graphql/cache';
import * as Sentry from '@sentry/nextjs';

import { clearFromCookies } from './cookies';

import { StorageTokens } from '@/lib/constants';

/**
 * Logouts the customer and clears the session tokens from storage.
 */
export const logout = async (cache: ApolloCache<object>) => {
  // Clear session tokens from storage
  clearFromCookies([
    StorageTokens.TOKEN,
    StorageTokens.REFRESH_TOKEN,
    StorageTokens.SELECTED_WORKSHOP_NAME,
    StorageTokens.SELECTED_WORKSHOP,
    StorageTokens.SELECTED_GROUP,
    StorageTokens.SELECTED_GROUP_NAME,
  ]);

  // Reset the apollo cache
  await cache.reset();

  // Clear the current user scope from Sentry
  Sentry.configureScope((scope) => scope.setUser(null));

  // Update the loggedIn variable
  loggedInVar(false);
};
